import React, { useState, useEffect, useRef } from 'react';

type Direction = 'up' | 'down' | 'left' | 'right';
type Segment = { x: number; y: number };

const SnakeGame: React.FC = () => {
  const [snake, setSnake] = useState<Segment[]>([{ x: 10, y: 10 }]);
  const [food, setFood] = useState<Segment>({ x: 5, y: 5 });
  const [direction, setDirection] = useState<Direction>('right');
  const [gameOver, setGameOver] = useState<boolean>(false);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const createFood = () => {
    let location: Segment = {
      x: Math.floor(Math.random() * 20),
      y: Math.floor(Math.random() * 20),
    };
    setFood(location);
  };

  useEffect(() => {
    const moveSnake = setInterval(() => {
      if (gameOver) {
        clearInterval(moveSnake);
        return;
      }

      const head: Segment = { x: snake[0].x, y: snake[0].y };

      switch (direction) {
        case 'up':
          head.y--;
          break;
        case 'down':
          head.y++;
          break;
        case 'left':
          head.x--;
          break;
        case 'right':
          head.x++;
          break;
      }

      if (head.x < 0 || head.y < 0 || head.x >= 20 || head.y >= 20) {
        setGameOver(true);
        return;
      }

      let newSnake = [...snake]; // Create a new copy of the snake

      if (head.x === food.x && head.y === food.y) {
        createFood();
      } else {
        newSnake.pop(); // Modify the new copy, not the original state
      }

      newSnake.unshift(head);
      setSnake(newSnake); // Set the state with the new copy
    }, 200);

    return () => clearInterval(moveSnake);
  }, [snake, direction, gameOver]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext('2d');
    if (!context) return;

    // Clear the canvas
    context.clearRect(0, 0, canvas.width, canvas.height);

    // Draw the snake
    snake.forEach((segment) => {
      context.fillStyle = 'green';
      context.fillRect(segment.x * 20, segment.y * 20, 20, 20);
    });

    // Draw the food
    context.fillStyle = 'red';
    context.fillRect(food.x * 20, food.y * 20, 20, 20);
  }, [snake, food]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    e.preventDefault();

    switch (e.key) {
      case 'ArrowUp':
        setDirection('up');
        break;
      case 'ArrowDown':
        setDirection('down');
        break;
      case 'ArrowLeft':
        setDirection('left');
        break;
      case 'ArrowRight':
        setDirection('right');
        break;
    }
  };

  return (
    <div onKeyDown={handleKeyDown} tabIndex={0} className="text-black">
      <h1>Snake Game</h1>
      {gameOver ? <h2>Game Over</h2> : null}
      <canvas ref={canvasRef} width={400} height={400} />
    </div>
  );
};

export default SnakeGame;
